import y from "@mui/icons-material/Done";
import { styled as e, Box as c, Typography as m, FormControlLabel as S, Checkbox as T } from "@mui/material";
import v from "../elements/CommunityAuthSection.js";
import A from "../elements/LoginAgreement.js";
import F from "../../../temp-lib/components/account/adeptus/AdeptusCodeInput.js";
import I from "../../../temp-lib/components/account/share/ConfirmPasswordTextField.js";
import L from "../../../temp-lib/components/account/share/EmailOTPSender.js";
import M from "../../../temp-lib/components/account/share/OTPCodeTextField.js";
import P from "../../../temp-lib/components/account/share/PasswordTextField.js";
import B from "../../../temp-lib/components/share/apeiron/ApeironBlueButton.js";
import { AdeptusInputMode as O } from "../../../temp-lib/constants/adeptus.js";
import { useAccountContext as _ } from "../../../temp-lib/contexts/account/AccountContext.js";
import { OTPType as E } from "../../../temp-lib/types/email.js";
import { useState as j, useCallback as a } from "react";
import { useForm as z, useWatch as R } from "react-hook-form";
import { useTranslation as $, Trans as D } from "react-i18next";
import { jsxs as l, jsx as o } from "react/jsx-runtime";
const N = e(c)`
  background-color: #1c1f25;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 40px;
  ${(t) => t.theme.breakpoints.up("res1024")} {
    width: 560px;
    overflow-y: auto;
  }
  ${(t) => t.theme.breakpoints.down("res1024")} {
    width: 100%;
  }
`, U = e(m)`
  font-size: 28px;
  font-weight: 700;
  margin-top: 40px;
`, W = e("form")`
  align-items: center;
  display: flex;
  flex-direction: column;
`, q = e(S)`
  margin-left: 0px;
  width: 100%;
`, G = e(m)`
  align-items: flex-start;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  font-weight: 300;
  justify-content: flex-start;
  white-space: pre-line;
  strong {
    color: #676869;
    font-size: 12px;
    font-weight: 300;
  }
`, H = e(T)`
  > .MuiSvgIcon-root {
    background-color: black;
    border-radius: 4px;
  }
  > .Mui-checked {
    color: black;
    :before {
      background-image: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath"+
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")";
    }
  }
`, J = e(c)`
  border-top: 1px dashed #979797;
  margin: 16px 0px;
  width: 100%;
`, K = e(B)`
  border-radius: 8px;
  height: 42px;
  margin: 10px 0;
  width: 100%;
`, Q = e(F)`
  margin-bottom: 16px;
  width: 100%;
`, uo = (t) => {
  const {
    className: p
  } = t, {
    t: i
  } = $(), {
    signUp: s
  } = _(), {
    control: n,
    trigger: d,
    handleSubmit: f
  } = z({
    mode: "onChange"
  }), u = R({
    name: "password",
    control: n
  }), [r, g] = j(!1), h = a(() => {
    g(!r);
  }, [r]), x = a(async (w) => {
    const {
      email: b,
      otpCode: C,
      password: k
    } = w;
    await s({
      email: b,
      otpCode: C,
      password: k,
      marketingMailOption: r
    });
  }, [r, s]);
  return /* @__PURE__ */ l(N, {
    className: p,
    children: [/* @__PURE__ */ o(U, {
      children: i("login.signup.title")
    }), /* @__PURE__ */ l(W, {
      onSubmit: f(x),
      children: [/* @__PURE__ */ o(L, {
        name: "email",
        control: n,
        otpType: E.AccountRegister
      }), /* @__PURE__ */ o(M, {
        name: "otpCode",
        control: n
      }), /* @__PURE__ */ o(P, {
        autoComplete: "new-password",
        control: n,
        name: "password"
      }), /* @__PURE__ */ o(I, {
        autoComplete: "new-password",
        control: n,
        name: "confirmPassword",
        password: u,
        trigger: d
      }), /* @__PURE__ */ o(q, {
        control: /* @__PURE__ */ o(H, {
          checked: r,
          onChange: h,
          checkedIcon: /* @__PURE__ */ o(y, {
            sx: {
              color: "white"
            }
          })
        }),
        label: /* @__PURE__ */ o(G, {
          children: /* @__PURE__ */ o(D, {
            children: i("account_setting.notification_settings_label.event_full_sentence")
          })
        })
      }), /* @__PURE__ */ o(K, {
        type: "submit",
        children: i("login.signup.register")
      })]
    }), /* @__PURE__ */ o(J, {}), /* @__PURE__ */ o(Q, {
      showFoot: !1,
      mode: O.AccountLogin
    }), /* @__PURE__ */ o(v, {}), /* @__PURE__ */ o(A, {})]
  });
};
export {
  uo as default
};
//# sourceMappingURL=SignupSection.js.map
